export default __webpack_public_path__ + "static/media/bubble_left.ed0e8f76.svg";